module.exports = "<div class=\"not-found\">\r\n  <h1 i18n>404</h1>\r\n  <h2 i18n>La pàgina que estàs buscant no existeix</h2>\r\n</div>\r\n"